class FlashServiceCtrl {
  constructor() {

  }
}

export default {
  bindings: {},
  templateUrl: 'services/flash-service/flash/flash.component.html',
  controller: FlashServiceCtrl
}